var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gat-grid',{attrs:{"items":_vm.budgetData,"columns":_vm.gridColumns}})
}
var staticRenderFns = []

export { render, staticRenderFns }